// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__iN37O","content":"LoadingAlert_content__q5gV6"};